import React from 'react';

const NoProductsFound = () => {
    return <div className="text-center">
        <img src={window.location.origin + "/images/no-products.png"} width="300" />
    </div>;
}

export default NoProductsFound;